import BaseApi from '../BaseApi';

const NotificationApi = {
  // Lịch sử thông báo (phân trang).
  // tag: 'Order' -> identifiers là mã đơn hàng | 'ProductTransaction' -> id lệnh giao dịch
  GetNotifications: (pageIndex: number, pageSize: number) => {
    return BaseApi.GET(`api/Notification/Get?PageIndex=${pageIndex}&PageSize=${pageSize}`);
  },

  // Đọc 1 thông báo (id lấy từ item trong GetNotifications)
  ReadNotification: (id: number) => {
    return BaseApi.PUT(`api/Notification/Read/${id}`, null);
  },

  // Tổng số thông báo CHƯA ĐỌC của user hiện tại (qua token), đếm phía server trên toàn bộ lịch sử
  // (không phụ thuộc trang đang tải). res.data.data = số
  GetAllUnreadAmount: () => {
    return BaseApi.GET('api/NotificationThirdParty/GetAllUnreadAmount');
  },

  // Đọc tất cả thông báo của user hiện tại (qua token)
  ReadAllNotifications: () => {
    return BaseApi.PUT('api/Notification/ReadAll', null);
  },

  // Chi tiết đơn hàng hỗn hợp — tự phân giải theo orderType phía backend.
  // Có thể đã tồn tại sẵn trong OrderApi của bạn; dùng lại nếu có thay vì khai báo trùng.
  GetOrderDetail: (maDonHang: string) => {
    return BaseApi.GET(`api/Order/GetDetail?madonhang=${maDonHang}`);
  }
};

export default NotificationApi;
